import React from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";

export const NavMenus = () => {
  const { pathname } = useLocation();

  const isActiveCn = (path) => {
    return path === pathname ? "active" : "";
  };

  return (
    <div className="navbar-wrap main-menu d-none d-lg-flex">
      <ul className="navigation">
        <li className={cn(isActiveCn("/"))}>
          <Link to="/">Home</Link>
        </li>

        <li className={cn(isActiveCn("/about"))}>
          <Link to="/about">About Us</Link>
        </li>

        <li className={cn(isActiveCn("/services"))}>
          <Link to="/services">Services</Link>
        </li>

        <li
          className={cn("menu-item-has-children", {
            active: ["/services-details", "/project-details", "/team-details"].includes(
              pathname
            ),
          })}
        >
          <a href="#">Pages</a>
          <ul className="sub-menu">
            <li className={cn(isActiveCn("/services-details"))}>
              <Link to="/services-details">Services Details</Link>
            </li>
            <li className={cn(isActiveCn("/project-details"))}>
              <Link to="/project-details">Portfolio Details</Link>
            </li>
            <li className={cn(isActiveCn("/team-details"))}>
              <Link to="/team-details">Team Details</Link>
            </li>
          </ul>
        </li>

        <li
          className={cn("menu-item-has-children", {
            active: ["/blog", "/blog-details"].includes(pathname),
          })}
        >
          <a href="#">Blog</a>
          <ul className="sub-menu">
            <li className={cn(isActiveCn("/blog"))}>
              <Link to="/blog">Our Blog</Link>
            </li>
            <li className={cn(isActiveCn("/blog-details"))}>
              <Link to="/blog-details">Blog Details</Link>
            </li>
          </ul>
        </li>

        <li className={cn(isActiveCn("/contact"))}>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </div>
  );
};
